import { isServer } from "solid-js/web";

import { isAndroid, isIos, isIosWebView, isSafari } from "@/lib/device";

export const getUserAgent = () => {
  if (isServer) {
    return (globalThis as Record<string, unknown>).__USER_AGENT__ as string;
  }
  return navigator.userAgent;
};

export const useDevice = () => {
  const userAgent = getUserAgent();
  return {
    isIos: isIos(userAgent),
    isAndroid: isAndroid(userAgent),
    isIosWebView: isIosWebView(userAgent),
    isSafari: isSafari(userAgent),
  };
};
